// Navigation Bar SECTION
const navBar = {
  show: true,
}

// Main Body SECTION
const mainBody = {
  gradientColors: '#ffb800 80%, #000',
  productName: 'PuTone',
  message: '音楽嗜好を可視化し、音楽を通して身近な人と繋がれる音楽SNS',
}

const about = {
  show: true,
  heading: '音楽を交換し合い、自分の音楽の幅が、感性が広がっていく。',
  imageSize: 400,
  message:
    '一人一人が音楽メディアになることで、アーティストもいろんな人に聴かれて、認知のきっかけも創造されていく。',
  gradientColors: 'to bottom, #000, #000',
}

export {
  navBar,
  mainBody,
  about,
}
